import api from 'api'
import AppAction from 'components/AppAction/AppAction'
import AppTableAction from 'components/AppAction/AppTableAction'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridMenu from 'components/AppGridLayout/AppGridMenu'
import AppGridTab from 'components/AppGridLayout/AppGridTab'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import { AppTable } from 'components/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import React, { Component } from 'react'

export default class DemoPage extends Component {
	render() {
		return (
			<AppGridLayout defaultViewId={2}>
				<AppGridSearch
					// projectFilter
					// projectFilterField="projectId"
					// projectFilterKeyName="projectId"
					// projectFilterType={1}
					// projectFilterLabel="项目"
					commonSearchList={[
						{ dataType: 'string', field: 'test', label: 'hah' },
						{ dataType: 'string', field: 'test2', label: 'hah3' },
					]}
					advancedSearch={{
						labelWidth: 110,
						appGridAdvancedSearchItemList: [
							{
								keyName: 'a1',
								type: 'text',
								field: 'a1',
								label: '面积变更id',
								dataType: 'text',
							},
						],
					}}
				/>

				<AppGridHeard>
					<AppGridTabs>
						<AppGridTab title="未审核" viewId={1}></AppGridTab>
						<AppGridTab title="审核中" viewId={2}></AppGridTab>
						<AppGridTab title="已审核" viewId={3}></AppGridTab>
						<AppGridTab title="全部" viewId={4}></AppGridTab>
					</AppGridTabs>
					<AppGridMenu>
						<AppAction title="新增" type="primary"></AppAction>
					</AppGridMenu>
				</AppGridHeard>

				<AppGridView viewId={1}>
					<AppTable api={api.modeling.entity.getPageList} paging>
						<AppTable.ColIndex title="序号" width={50} />
						<AppTable.Col title="中文名" field="displayName" width={200} />
						<AppTable.Col title="英文名" field="name" width={200} />
						<AppTable.Col title="状态" field="state" width={100} />
						<AppTable.Col title="修改人" field="modifiedBy" width={200} />
						<AppTable.Col title="修改时间" field="modifiedOn" width={150} />
						<AppTable.ColAction width={300}>
							<AppTableAction label="复制" actionCode="66931201" />
						</AppTable.ColAction>
					</AppTable>
				</AppGridView>
				<AppGridView viewId={2}>
					<AppTable api={api.modeling.entity.getPageList}>
						<AppTable.ColIndex title="序号" width={50} />
						<AppTable.Col title="中文名" field="displayName" width={200} />
						<AppTable.Col title="英文名" field="name" width={200} />
						<AppTable.Col title="状态" field="state" width={100} />
						<AppTable.Col title="修改人" field="modifiedBy" width={200} />
						<AppTable.Col title="修改时间" field="modifiedOn" width={150} />
						<AppTable.ColAction
							width={300}
							render={() => {
								return <AppTableAction label="复制" />
							}}
						></AppTable.ColAction>
					</AppTable>
				</AppGridView>

				{/* <AppLayout>
					
				</AppLayout> */}
				{/* <View/>
        <View/> */}
			</AppGridLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/GridDemo.tsx